import { validateRedirectProtocol } from '../security'

const urlPrefix = 'redirect-'

export const replaceStateParamWithRedirectUrl = (
  url: string,
  value: string
) => {
  const urlObj = new URL(url)

  urlObj.searchParams.set('state', urlPrefix + value)

  return urlObj.toString()
}

export const isStateParamARedirectUrl = (state: string) => {
  if (!state) {
    return false
  }

  return state.startsWith(urlPrefix)
}

export const extractRedirectUrlFromStateParam = (
  state: string
): string | null => {
  if (!state) {
    return null
  }

  const extracted = state.replace(urlPrefix, '')
  // Validate protocol — domain may be a custom partner domain
  return validateRedirectProtocol(extracted)
}
